import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { connect, useSelector, shallowEqual, useDispatch } from 'react-redux';
import Badge from '../../atoms/badge/badge';
import Label from '../../atoms/label/label';
import swal from 'sweetalert';
import { IconType } from '../../atoms/icon/icon';
import { useLocation } from 'react-router-dom';
import Button, { ButtonTheme } from '../../atoms/button/button';
import Modal, { ModalSize } from '../../molecules/modal/modal';
import { getItems, createItem, removeItem, tableEdited, updateItems } from '../../../store/externalCalls/api/secondaryListTableApi';
import { storeStructure } from '../../../store/reducers';
import { composeURL, checkObjectAttributes, composeURLByQuery } from '../../../utils/urlTools';
import ListTableComponent from '../listTableComponent/listTableComponent';

const FormRelationshipFilter = (props) => {
  const {
    value, helpText, label, isForm, configFile, onChange, 
    onCreate, onDelete, onSave, buttonColor,id,customParams,disabled,maxElements,onSelectUrl,canEdit,dataRow,filterByParticularId,blockItemRemove,popupSize
  } = props;
  
  const location = useLocation();
  const match = {
    url: location.pathname,
  };
  const dispatch = useDispatch();
  const values = useSelector((state) => state[storeStructure.ListTable], shallowEqual);
  const [openModal, setOpenModal] = useState(false);
  const [paginateValues, setPaginatedValues] = useState([]);
  const [updatedValues, setUpdateValues] = useState();
  const [errors, setErrors] = useState({});
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const [itemsSelected, setItemsSelected] = useState(value);
  const [disabledValue,setDisabledValue] =useState(disabled);
  let valueParams=(customParams?JSON.parse(customParams):null);
  const getData = (changePage) => {
    let params = {
      ...(valueParams ? valueParams : session)
    };
    const idAttribute = configFile.idAttribute !== undefined
      ? params[configFile.idAttribute] : undefined;
    const compose = configFile.useQueryParams ? composeURLByQuery : composeURL;
    if (configFile.parentParams && dataRow) {
       configFile.parentParams.forEach(({field,param,valueField = 'id',multiple = false}) => {
        const value = dataRow[field];
        if (Array.isArray(value)) {
          if (multiple) {
            params[param] = value
              .map(item => item?.[valueField])
              .filter(v => v !== undefined && v !== null);
          } else if (value.length > 0) {
            params[param] = value[0][valueField];
          }
        } else if (value?.[valueField] !== undefined) {
          params[param] = value[valueField];
        }
      });
    }
    if (filterByParticularId) {
      let f = { ...params };
      f[filterByParticularId.field] = dataRow[filterByParticularId.value];
      getItems(compose(f, configFile.sessionParams, configFile.getURL, idAttribute))
        .then((paginatedItems) => {
          setPaginatedValues(paginatedItems);
          setOpenModal(true);
          (value.length > 0) ? setItemsSelected(value) : setItemsSelected(itemsSelected);
        });
    }
    if (checkObjectAttributes((valueParams?valueParams:session), configFile.sessionParams)) {
      getItems(changePage || composeURL((valueParams?valueParams:session), configFile.sessionParams, configFile.getURL,idAttribute))
        .then((paginatedItems) => {
          setPaginatedValues(paginatedItems);
          setOpenModal(true);
          (value?.length > 0) ? setItemsSelected(value) : setItemsSelected(itemsSelected);
        });
    }
  };
  const handlerChangePage = (e) => {
    getData(e);
  };
  const handlerOpenModal = () => {
    setItemsSelected(Array.isArray(value) ? value.filter(Boolean) : (value ?? {}));
    getData();
  };
  // useEffect(() => {
  //   // if(maxElements && value.length>=maxElements){
  //   //   setDisabledValue(true);
  //   // }else
  //   //   setDisabledValue(disabled);
  // },[value]);

  const handlerErrors = (e) => {
    const messages = e.errors === undefined ? { general: 'Something was wrong' } : e.errors;

    setErrors(messages);
    setTimeout(() => {
      setErrors({});
    }, 5000);
  };

  const handlerCreate = (item) => {
    setErrors({});
    const url = composeURL((valueParams?valueParams:session), configFile.sessionParams, configFile.createURL, id);
    createItem(
      url,
      item,
      dispatch,
    ).then(() => {
      // eslint-disable-next-line max-len
      getItems(composeURL((valueParams?valueParams:session), configFile.sessionParams, configFile.getURL)).then((paginatedItems) => {
        setPaginatedValues(paginatedItems);
        setOpenModal(true);
      });
    }, (e) => {
      handlerErrors(e);
    });
  };
  const handlerRemoveItem = (item) => {
    swal({
      title: 'Are you sure?',
      text: 'You are removing a item.',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const url = composeURL((valueParams?valueParams:session), configFile.sessionParams, configFile.removeURL, id);
        removeItem(url, item, dispatch).then((result) => {
          getData();
          onDelete(result);
        }, (e) => {
          handlerErrors(e);
        });
      }
    });
  };
  const handlerUpdate = (dataSet) => {
    setUpdateValues(dataSet);
    if (configFile.autoUpdate === true) {
      const url = composeURL((valueParams?valueParams:session), configFile.sessionParams, configFile.updateURL, id);

      updateItems(url, dataSet, dispatch)
        .then(() => {
          onSave();
        }, (e) => {
          handlerErrors(e);
        });
    } else {
      tableEdited(dispatch);
    }
  };
  const handlerClickRow = (newItemSelected) => {
    setItemsSelected(newItemSelected);
  };

  const handlerCloseModal = () => {
    setOpenModal(false);
  };

  const handlerSave = () => {
    onChange({ target: { value: itemsSelected } });
    setItemsSelected([]);
    handlerCloseModal();
  };

  const handlerOnClickBadge = (item) => {
    const lockRule = configFile.blockRemoveWhenInField;
    if (lockRule && dataRow) {
      const compareKey = lockRule.compareKey || 'id';
      let lockedValue = dataRow[lockRule.field];
      
      if (Array.isArray(lockedValue)) {
        lockedValue = lockedValue.length > 0 ? lockedValue[0] : null;
      }

      if (lockedValue && item?.[compareKey] === lockedValue?.[compareKey]) {
        swal({
          title: 'Locked',
          text: `${lockRule.message ?? ''}`,
          icon: 'warning',
          button: 'OK',
        });
        return;
      }
    }

    if (configFile.tableConfig.isMultiSelectable) {
      const newItems = [...value];
      newItems.splice(newItems.indexOf(item), 1);
      onChange({ target: { value: newItems } });
    } else {
      onChange({ target: { value: {} } });
    }
  };
  const handlerOnChange=(e)=>{
    if(configFile.tableConfig.isMultiSelectable==false){
      setItemsSelected(e.target.value);
    }else{
      setItemsSelected(e.target.value);
    }
  }
  const handlerChangeAndRefresh=(e)=>{
    console.log("to be defined if necessary");
  }
 const normalizedArray = Array.isArray(value) ? value.filter(Boolean) : [];
 const normalizedObject = (!Array.isArray(value) && value && typeof value === 'object') ? value : null;
  const getItemName = (item) => {
    const itemNames = Array.isArray(configFile.itemName)
      ? configFile.itemName
      : [configFile.itemName];

    return itemNames.find((name) => item?.[name] !== undefined && item?.[name] !== null)
      ? item[itemNames.find((name) => item?.[name] !== undefined && item?.[name] !== null)]
      : '';
  };
  return (

    <div className={isForm === true ? 'form-group row' : ''}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
      <div className={isForm === true ? 'col-sm-8' : ''}>
        {canEdit && Array.isArray(value) && (!blockItemRemove || blockItemRemove==false) && normalizedArray.map((val) => (
          <Badge
            className="mr-1"
            key={val[configFile.itemId]}
            id={val[configFile.itemId]}
            icon={IconType.CLOSE}
            onClick={() => handlerOnClickBadge(val)}
          >
            {getItemName(val)}
          </Badge>
        ))}
        {(!canEdit || blockItemRemove) &&  Array.isArray(value) && normalizedArray.map((val) => (
          <Badge
            className="mr-1"
            key={val[configFile.itemId]}
            id={val[configFile.itemId]}
          >
            {val[configFile.itemName]}
          </Badge>
        ))}
        {!Array.isArray(value) &&normalizedObject&& normalizedObject[configFile.itemId]  !== undefined 
          && (
           <Badge
            className="mr-1"
            key={value[configFile.itemId]}
            id={value[configFile.itemId]}
          >
            {getItemName(value)}
          </Badge>
          )}
        {canEdit 
          && (
            <Button id={id}
              theme={buttonColor ? buttonColor : ButtonTheme.PRIMARY}
              icon={IconType.NEW}
              disabled={disabledValue}
              onClick={handlerOpenModal}
            />
          )}
          {maxElements && normalizedArray.length >= maxElements && (!blockItemRemove || blockItemRemove==false)&& <> (reached max of items allowed)</>}
      </div>
      { openModal === true
      && (
        <Modal
          title={configFile.title}
          onClose={handlerCloseModal}
          size={popupSize?popupSize:ModalSize.LARGE}
          dialogClassName={configFile?.dialogClassName || ''}
        >
           <ListTableComponent
                classId={`${configFile.attributeName}`}
                key={configFile.attributeName }
                configFile={configFile.tableConfig}
                tableName={configFile.attributeName}
                filterByParticularId={filterByParticularId?{[filterByParticularId.field]:dataRow[filterByParticularId.value]}:null}
                mode={'POPUP'}
                onChange={(event) => handlerOnChange({ target: { value: event } }, configFile.attributeName)}
                onChangeAndRefresh={handlerChangeAndRefresh}
                value={(paginateValues? paginateValues : '')}
                itemId={configFile.itemId}
                maxElementsSelectable={maxElements}
                dataSelected={configFile.tableConfig.isMultiSelectable === true ? itemsSelected : itemsSelected}
                match={match}
              />
          <div>
            <Button
              theme={ButtonTheme.PRIMARY}
              onClick={handlerSave}
              disabled={itemsSelected === undefined}
            >
              Ok
            </Button>
          </div>
        </Modal>
      )}
    </div>
  );
};

FormRelationshipFilter.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
    PropTypes.oneOf([null])
  ]),
  configFile: PropTypes.shape({
    itemId: PropTypes.string,
    getURL: PropTypes.string,
    itemName: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    createURL: PropTypes.string,
    removeURL: PropTypes.string,
    autoUpdate: PropTypes.bool,
    updateURL: PropTypes.string,
    idAttribute: PropTypes.string,
    title: PropTypes.string,
    sessionParams: PropTypes.arrayOf(PropTypes.string),
    dialogClassName: PropTypes.string,
    tableConfig: PropTypes.shape({
      isMultiSelectable: PropTypes.bool,
    }),
  }).isRequired,
  onSelectUrl: PropTypes.string,
  maxElements: PropTypes.number,
  onChange: PropTypes.func,
  onCreate: PropTypes.func,
  onDelete: PropTypes.func,
  onSave: PropTypes.func,
  isForm: PropTypes.bool,
  label: PropTypes.string,
  helpText: PropTypes.string,
  canEdit: PropTypes.bool,
};

FormRelationshipFilter.defaultProps = {
  label: '',
  helpText: '',
  value: [],
  onChange: () => {},
  onCreate: () => {},
  onDelete: () => {},
  onSave: () => {},
  isForm: false,
  canEdit:true,
};

export default connect()(FormRelationshipFilter);
